import CustomSpeechBubble from './CustomSpeechBubble'
export default class BubbleManager {
  constructor (bubblecontainer, editor) {
    this.bubbleContainer = bubblecontainer
    this.editor = editor
    console.log('this.editor', this.editor)
    this.bubbleNavi = document.getElementById('nav-bubble')
    this.init()
  }
}
BubbleManager.prototype.init = function () {
  this.bubbleList = []
  this.activeBubble = null
}
BubbleManager.prototype.addBubble = function (x, y, container) {
  console.log('add', this.editor)
  var bubble = new CustomSpeechBubble(this, container, x, y, this.editor)

  this.bubbleList.push(bubble)
  return bubble
}

BubbleManager.prototype.showBubbleNavi = function (x, y) {
// this.bubbleNavi.style.display = "block";
}

BubbleManager.prototype.hideBubbleNavi = function (x, y) {
  // this.bubbleNavi.style.display = "none";
}

BubbleManager.prototype.deactivateAllBubbles = function () {
  var cur_bubble
  for (var i = 0; i < this.bubbleList.length; i++) {
    cur_bubble = this.bubbleList[i]
    cur_bubble.mode = CustomSpeechBubble.modes.NORMAL
  }
  this.hideBubbleNavi()
}

Object.defineProperty(BubbleManager.prototype, 'activeEditBubble', {
  get: function () {
    var cur_bubble = null
    for (var i = 0; i < this.bubbleList.length; i++) {
      cur_bubble = this.bubbleList[i]
      if (cur_bubble.mode === CustomSpeechBubble.modes.edit) {
        break
      }
    }
    return cur_bubble
  },
  set: function (_active_edit_bubble) {
    this.deactivateAllBubbles()
    _active_edit_bubble.mode = CustomSpeechBubble.modes.EDIT
    this.showBubbleNavi()
  }
})
